import React, { useState } from 'react';

import {
  Lightbox as LightboxComponent,
  LightboxImage,
} from '../components/Lightbox';

export const useLightbox = () => {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState<LightboxImage | null>(null);

  const openLightbox = (img: LightboxImage) => {
    setImage(img);
    setOpen(true);
  };

  const closeLightbox = () => {
    setOpen(false);
    // Clear image after animation completes
    setTimeout(() => setImage(null), 200);
  };

  return {
    open,
    image,
    openLightbox,
    closeLightbox,
  };
};

export const useLightboxComponent = () => {
  const { open, image, openLightbox, closeLightbox } = useLightbox();

  // Return the JSX element directly - just render it in your component
  const Lightbox = (
    <LightboxComponent open={open} onClose={closeLightbox} image={image} />
  );

  return {
    Lightbox,
    openLightbox,
  };
};
